import {
  LayoutDashboard, Brain, Users, GitBranch,
  ClipboardList, MessageCircle, Siren, Layers,
  UserSearch, Navigation, HeartPulse, Sword,
  Megaphone, ShieldCheck,
  Radar, Server, Shield, Camera,
  Star, Gauge, Map, Plug,
} from "lucide-react";

// ── navigation items ─────────────────────────────────────────────
// Single source of truth shared by the horizontal MenuBar (desktop primary
// nav — one row of section names, each opening a dropdown of that section's
// pages) and the vertical Sidebar (mobile/tablet slide-in drawer). `section`
// groups consecutive items under one heading; the same object reference
// marks where a new group starts, so grouping is a single pass with no
// second lookup table to keep in sync.
export const navItems = [
  // ── overview ──────────────────────────────────────────────────
  { path:"/",                   label:{en:"Command Overview",       mr:"कमांड विहंगावलोकन"},        icon:LayoutDashboard, badge:null,     section:null              },
  /* Kumbh Sathi is launched from the dashboard overview panel, not browsed
     from the nav. The route stays live — existing links still work. */

  // ── maha ai: strategic ────────────────────────────────────────
  { path:"/executive",          label:{en:"Executive Intelligence", mr:"एक्झिक्युटिव्ह इंटेलिजन्स"}, icon:Star,            badge:null,     section:{en:"Strategic", mr:"स्ट्रॅटेजिक"} },
  { path:"/risk-intelligence",  label:{en:"Multi-Hazard Risk",      mr:"बहु-धोका जोखीम"},            icon:Radar,           badge:"62",     section:{en:"Strategic", mr:"स्ट्रॅटेजिक"} },

  // ── operations ────────────────────────────────────────────────
  { path:"/command",            label:{en:"War Room",               mr:"वॉर रूम"},                   icon:Sword,           badge:"18",     section:{en:"Operations", mr:"ऑपरेशन्स"} },
  { path:"/crowd-intelligence", label:{en:"Crowd Risk Engine",      mr:"गर्दी जोखीम इंजिन"},          icon:Users,           badge:"HIGH",   section:{en:"Operations", mr:"ऑपरेशन्स"} },
  { path:"/geo-intelligence",   label:{en:"Geospatial Intelligence",mr:"भू-स्थानिक इंटेलिजन्स"},    icon:Map,             badge:"MAP",    section:{en:"Operations", mr:"ऑपरेशन्स"} },
  { path:"/digital-twin",       label:{en:"Digital Twin Sim",       mr:"डिजिटल ट्विन सिम्युलेशन"},   icon:GitBranch,       badge:null,     section:{en:"Operations", mr:"ऑपरेशन्स"} },

  // ── field & citizen (maha kumbh ai) ───────────────────────────
  { path:"/field-ops",          label:{en:"Field Copilot",          mr:"फील्ड कोपायलट"},             icon:ClipboardList,   badge:"3",      section:{en:"Pilgrim Help", mr:"यात्रेकरू मदत"} },
  { path:"/pilgrim-support",    label:{en:"Pilgrim Guidance",       mr:"यात्रेकरू मार्गदर्शन"},       icon:MessageCircle,   badge:null,     section:{en:"Pilgrim Help", mr:"यात्रेकरू मदत"} },
  { path:"/missing",            label:{en:"Missing Persons",        mr:"हरवलेल्या व्यक्ती"},          icon:UserSearch,      badge:"8",      section:{en:"Pilgrim Help", mr:"यात्रेकरू मदत"} },
  { path:"/public-comms",       label:{en:"Public Comms & Trust",   mr:"जनसंवाद व विश्वास"},         icon:Megaphone,       badge:null,     section:{en:"Pilgrim Help", mr:"यात्रेकरू मदत"} },

  // ── emergency & safety ────────────────────────────────────────
  { path:"/emergency",          label:{en:"Emergency Response",     mr:"आपत्कालीन प्रतिसाद"},         icon:Siren,           badge:"6",      section:{en:"Emergency & Safety", mr:"आपत्कालीन व सुरक्षा"} },
  { path:"/services",           label:{en:"Service Stress",         mr:"सेवा ताण"},                   icon:Layers,          badge:null,     section:{en:"Emergency & Safety", mr:"आपत्कालीन व सुरक्षा"} },
  { path:"/mobility",           label:{en:"Mobility Intelligence",  mr:"वाहतूक इंटेलिजन्स"},          icon:Navigation,      badge:null,     section:{en:"Emergency & Safety", mr:"आपत्कालीन व सुरक्षा"} },
  { path:"/health",             label:{en:"Health & Epidemic",      mr:"आरोग्य व साथरोग"},            icon:HeartPulse,      badge:null,     section:{en:"Emergency & Safety", mr:"आपत्कालीन व सुरक्षा"} },

  // ── disaster & infrastructure ─────────────────────────────────
  { path:"/disaster-mgmt",      label:{en:"Disaster Management",    mr:"आपत्ती व्यवस्थापन"},          icon:Shield,          badge:"NDRF",   section:{en:"Disaster & Infrastructure", mr:"आपत्ती व पायाभूत सुविधा"} },
  { path:"/infrastructure",     label:{en:"Infrastructure Resilience", mr:"पायाभूत सुविधा लवचिकता"}, icon:Server,          badge:"2",      section:{en:"Disaster & Infrastructure", mr:"आपत्ती व पायाभूत सुविधा"} },
  { path:"/police-modern",      label:{en:"Police Modernization",   mr:"पोलीस आधुनिकीकरण"},          icon:Camera,          badge:null,     section:{en:"Disaster & Infrastructure", mr:"आपत्ती व पायाभूत सुविधा"} },

  // ── command & governance ──────────────────────────────────────
  { path:"/ai-assurance",       label:{en:"AI Stack Assurance",     mr:"एआय स्टॅक हमी"},             icon:Brain,           badge:null,     section:{en:"Command & Governance", mr:"कमांड व प्रशासन"} },
  { path:"/ai-trust",           label:{en:"AI Trust Centre",        mr:"एआय विश्वास केंद्र"},         icon:Gauge,           badge:null,     section:{en:"Command & Governance", mr:"कमांड व प्रशासन"} },
  { path:"/governance",         label:{en:"DPDP & Governance",      mr:"डीपीडीपी व प्रशासन"},         icon:ShieldCheck,     badge:null,     section:{en:"Command & Governance", mr:"कमांड व प्रशासन"} },
  { path:"/kumbhathon",         label:{en:"Kumbhathon Integration", mr:"कुंभथॉन एकत्रीकरण"},          icon:Plug,            badge:"8",      section:{en:"Command & Governance", mr:"कमांड व प्रशासन"} },
];

// Badge text -> pill colour. "HIGH"/"CRITICAL"/"NDRF" are severity words
// rather than counts, so they're matched by name before falling through to
// the numeric-threshold bands.
export const badgeColor = (val) => {
  if (val === "HIGH" || val === "CRITICAL" || val === "NDRF") return "bg-red-100 text-red-700";
  const n = parseInt(val, 10);
  if (!isNaN(n)) {
    if (n >= 10) return "bg-red-100 text-red-700";
    if (n >= 5)  return "bg-amber-100 text-amber-700";
    return "bg-sky-100 text-sky-700";
  }
  return "bg-amber-100 text-amber-700";
};

/**
 * Groups consecutive nav items sharing the same `section` object into
 * { key, heading, items[] } blocks. Items with no section (Command Overview,
 * Kumbh Sathi) each get their own single-item block — MenuBar renders a
 * headingless block as one direct link (group.items[0]), so two ungrouped
 * items sitting back to back must never be merged into one block or the
 * second item silently disappears from the desktop bar. Both the MenuBar's
 * section triggers and the Sidebar's collapsible headings are built from
 * this same grouping, so the two navs can never drift apart on which pages
 * belong to which section.
 */
export function groupBySection(items) {
  const groups = [];
  let current = null;
  for (const item of items) {
    const key = item.section ? item.section.en : null;
    if (!current || current.key !== key || key === null) {
      current = { key, heading: item.section, items: [] };
      groups.push(current);
    }
    current.items.push(item);
  }
  return groups;
}

export const NAV_GROUPS = groupBySection(navItems);

// Badge values are either small integers ("18", "8") or severity words
// ("HIGH", "NDRF"). A section-level summary badge (shown on the MenuBar
// trigger, mirroring how the rail badges each item) sums only the numeric
// ones — a severity word can't be added to a count without inventing a
// number nobody reported, so it's surfaced by marking the group "urgent"
// instead and leaving the numeric sum to speak for the rest.
export function sectionBadge(items) {
  let sum = 0;
  let urgent = false;
  for (const item of items) {
    if (!item.badge) continue;
    const n = parseInt(item.badge, 10);
    if (!isNaN(n)) { sum += n; continue; }
    urgent = true;
  }
  return { count: sum, urgent };
}

export const LIVE_DEMO = { en: "Live Demo", mr: "थेट डेमो" };
// Static page in public/ — PUBLIC_URL keeps it working under the /kumbh-ai
// GitHub Pages base path (a bare "/dashboard_link.html" would 404 there).
export const LIVE_DEMO_URL = `${process.env.PUBLIC_URL}/dashboard_link.html`;

export const BRAND_NAME = { en: "Maha Kumbh AI", mr: "महा कुंभ एआय" };
